import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useRememberMe = (currentPromo) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (currentPromo && localStorage.getItem('accessToken')) {
            navigate(`/${currentPromo.path}/home`);
        }
    }, [currentPromo, navigate]);

};

export default useRememberMe;
